import { BrickContext, VisualBrick, registerBrick } from 'olympe';
import * as d3 from 'd3';
import { combineLatest } from 'rxjs';

type Properties = [
  data: unknown[],
  width: number,
  height: number,
  xScaleRange: number[],
  yScaleRange: number[],
  yLabel: string,
  xLabel: string,
  color: string
];

const CHART_CN = 'line-chart';

export default class LineChart extends VisualBrick {
  protected setupExecution($: BrickContext) {
    const observeData = $.observe('data');
    const observeWidth = $.observe('width');
    const observeHeight = $.observe('height');
    const observeXScaleRange = $.observe('xScaleRange');
    const observeYScaleRange = $.observe('yScaleRange');
    const observeYLabel = $.observe('yLabel');
    const observeXLabel = $.observe('xLabel');
    const observeColor = $.observe('color');

    return combineLatest([
      observeData,
      observeWidth,
      observeHeight,
      observeXScaleRange,
      observeYScaleRange,
      observeYLabel,
      observeXLabel,
      observeColor,
    ]);
  }

  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {!Array<*>} properties
   * @return {Element}
   */
  protected render(
    $: BrickContext,
    [
      data,
      width,
      height,
      xScaleRange,
      yScaleRange,
      yLabel,
      xLabel,
      color,
    ]: Properties
  ) {
    // Write your code here. You have to implement this method !
    // This method returns the rendered element that is attached to its parent with the overridable method `updateParent()`.
    // Executed only once by default, override `setupExecution()` to change the behavior and control the `properties` parameter.

    // Workaround, as it is not possible to rerender only part of component written in JS
    d3.select(`.${CHART_CN}`).remove();

    const svg = d3
      .create('svg')
      .attr('class', CHART_CN)
      .attr('width', width)
      .attr('height', height);
    const xScale = d3
      .scaleLinear()
      .domain(xScaleRange)
      .range([0, width - 150]);
    const yScale = d3.scaleLinear().domain(yScaleRange).range([450, 0]);

    const g = svg
      .append('g')
      .attr('transform', 'translate(' + 50 + ',' + 100 + ')');

    g.append('g')
      .attr('transform', 'translate(0,' + 450 + ')')
      .call(d3.axisBottom(xScale));

    g.append('g').call(d3.axisLeft(yScale));

    g.selectAll('g').attr('class', 'axis');

    svg
      .append('g')
      .selectAll('dot')
      .data(data)
      .enter()
      .append('circle')
      .attr('cx', (d, i) => xScale(i))
      .attr('cy', (d: { rtt: number }) => yScale(d.rtt))
      .attr('r', 3)
      .attr('transform', 'translate(' + 50 + ',' + 100 + ')')
      .style('fill', color);

    const line = d3
      .line()
      .x((d, i) => xScale(i))
      .y((d: any) => yScale(d.rtt))
      .curve(d3.curveMonotoneX);

    svg
      .append('path')
      .datum(data)
      .attr('transform', 'translate(' + 50 + ',' + 100 + ')')
      .attr('d', line as any)
      .style('fill', 'none')
      .style('stroke', color)
      .style('stroke-width', '2');

    svg
      .append('text')
      .attr('text-anchor', 'start')
      .attr('x', 10)
      .attr('y', 80)
      .text(yLabel)
      .style('fill', color);

    return svg.node();
  }
}

registerBrick('01899b6eed5318148d9a', LineChart);
